require("./accountLastMovementsTableRow.scss");

const PropTypes = require("prop-types");

// @ vendors
const React = require("react");
const { connect } = require("react-redux");
const classnames = require("classnames");

// @ core
const { formatText, FormattedText, getLanguage } = require("core/i18n").i18n;

const { Link } = require('react-router-dom');
// @ helpers
const { toCamelCase } = require("utilities/stringHelper");
const {
    formatAmountObject,
    getPlainAmountObject,
} = require("utilities/currencyHelper");
const {
    LAVANDA,
    PFM,
    PFM_NEW_FEATURES,
} = require("constants/flagBasedFeatures");
const { getCategoryIcon } = require("constants/categories");
const { recordLink } = require("utilities/tagging");

// @ components
const TruncateText = require("components/commons/truncateText/truncateText");
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");
const {
    OKIconCategorization,
} = require("commonsComponents/OKIconCategorization");
const { OKTableRow } = require("commonsComponents/OKTableRow");
const { OKTableCell } = require("commonsComponents/OKTableCell");
const {
    OKCollapsingToggler,
} = require("commonsComponents/OKCollapsingToggler");
const OKTag = require("components/commons/OKTag/OKTag");
const {
    OneLineSymbolAmount,
} = require("commonsComponents/oneLineSymbolAmount");
const { LabelDate } = require("commonsComponents/labelDate");
const ContactCenterRender = require("components/conditionalRender/contactCenterRender");
const WebappRender = require("components/conditionalRender/webappRender");
import FeatureTogglingRender from "components/conditionalRender/featureTogglingRender";
// @ actions
const { open } = require("actions/categoryUpdate");
// @ constants
const { CATEGORY_TYPE_ACCOUNT } = require("constants/index");
const {
    getCategoryIconURL,
} = require("utilities/expensesByCategories/categoriesUtilities");
const {
    LABEL_DATE_TODAY,
    LABEL_DATE_YESTERDAY,
} = require("constants/commonsComponents");
const {
    ACCOUNT_DEFERRED_PAYMENT,
    ACCOUNT_DEFERRABLE_PAYMENT,
    ACCOUNT_NOT_DEFERRABLE_PAYMENT,
} = require("constants/index");
const {
    DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT,
    DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT,
} = require("constants/tagging");

class AccountLastMovementsTableRow extends React.Component {
    constructor(props) {
        super(props);

        this.onRowClick = this.onRowClick.bind(this);
        this.handleOpenCategoriesModal =
            this.handleOpenCategoriesModal.bind(this);
    }

    componentDidMount() {
        const { id, accountDeepLinkResponse, immTransaction } = this.props;
        if (
            (accountDeepLinkResponse["description"] || "").trim() ===
                (immTransaction.get("description") || "").trim() &&
            accountDeepLinkResponse["date"] === immTransaction.get("date") &&
            accountDeepLinkResponse["amount"] ===
                immTransaction.getIn(["balance", "amount"])
        ) {
            this.onRowClick(id);
            const element = document.getElementById(id);
            const ROW_HEADER_OFFSET = 250;
            element &&
                window.scrollTo(0, element.offsetTop + ROW_HEADER_OFFSET);
        }
    }

    onRowClick() {
        const { id, onRowClick } = this.props;

        onRowClick(id);
    }

    handleOpenCategoriesModal() {
        const { immTransaction, openCategoriesModal } = this.props;

        openCategoriesModal(
            CATEGORY_TYPE_ACCOUNT,
            immTransaction.get("accountId"),
            immTransaction.get("id"),
            immTransaction.get("category"),
            immTransaction.get("subcategory"),
            immTransaction.get("description"),
            immTransaction.get("date"),
            immTransaction.getIn(["balance", "amount"]),
            immTransaction.get("categoryCode"),
            immTransaction.get("subCategoryCode")
        );
    }

    getValueDateCell(immTransaction, dateRowClass, id) {
        const canRenderAdditionalColumn = id.includes("account-last-movements");
        const valueDate = immTransaction.get("valueDate");
        const labelDateComponent = valueDate ? (
            <LabelDate
                date={valueDate}
                language={getLanguage()}
                today={<FormattedText value="labelDate-today" />}
                yesterday={<FormattedText value="labelDate-yesterday" />}
            />
        ) : (
            "-"
        );
        let valueDateCell = (
            <OKTableCell className={dateRowClass}>
                {labelDateComponent}
            </OKTableCell>
        );
        if (!canRenderAdditionalColumn) valueDateCell = null;

        return valueDateCell;
    }

    renderDeferrablePayment(immTransaction) {
        const { flagBasedFeatures } = this.props;
        const accountId = immTransaction.get("accountId");
        const showPendingValoration =
            immTransaction.get("showPendingValoration") &&
            flagBasedFeatures.get("web-movement-fecha-valor-enabled");
        const tagClassName = classnames(
            "account-last-movements-table-row__cell-deferrable",
            {
                "account-last-movements-table-row__cell-pending":
                    showPendingValoration,
            }
        );
        let tag;
        if (showPendingValoration) {
            const transferPendingTag = formatText(
                "accounts-accounts_transferPendingTag"
            );
            const transferPendingTooltipText = formatText(
                "accounts-accounts_transterPendingTooltipText"
            );
            tag = (
                <React.Fragment>
                    <OKTag content={transferPendingTag} type="informative" />
                    <span className="account-last-movements-table-row__pending-tag-tool-tip">
                        <OKTooltip
                            content={transferPendingTooltipText}
                            type="custom"
                        />
                    </span>
                </React.Fragment>
            );
        } else {
            switch (immTransaction.get("finance")) {
                case ACCOUNT_DEFERRABLE_PAYMENT:
                    const id = immTransaction.get("id");

                    tag = (
                        <Link
                            className="account-information__link"
                            onClick={() =>
                                flagBasedFeatures.get(LAVANDA) &&
                                recordLink(
                                    window.utag_last_name,
                                    DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT,
                                    DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT
                                )
                            }
                            to={`/myprofile/accounts/${accountId}/defer-payment/${id}`}
                        >
                            <OKTag
                                content={"accountTransactions-defer"}
                                type="action"
                            />
                        </Link>
                    );
                    break;
                case ACCOUNT_DEFERRED_PAYMENT:
                    tag = (
                        <OKTag
                            content={"accountTransactions-deferred"}
                            type="disabled"
                        />
                    );
                    break;
                case ACCOUNT_NOT_DEFERRABLE_PAYMENT:
                default:
                    tag = "";
                    break;
            }
        }

        return <OKTableCell className={tagClassName}>{tag}</OKTableCell>;
    }

    render() {
        const {
            immTransaction,
            id,
            isExpanded,
            isExpandable,
            flagBasedFeatures,
            charLimit,
        } = this.props;
        const language = getLanguage();
        const NEW_PFM_FEATURES = flagBasedFeatures.get(PFM_NEW_FEATURES);
        const category = immTransaction.get("category");
        const subcategory = immTransaction.get("subcategory");
        const categoryIcon = NEW_PFM_FEATURES
            ? getCategoryIconURL(category)
            : getCategoryIcon(category);

        const subCategoryTextClass = classnames(
            "account-last-movements-table-row__category-tooltip-subtitle",
            {
                "account-last-movements-table-row__category-tooltip-paragraph":
                    immTransaction.get("canBeRecategorized"),
            }
        );

        let categoryTooltip;
        let editCategoryButton;
        let cantBeCategorizedInfoMessage;

        if (category) {
            const categoryText = formatText(
                NEW_PFM_FEATURES
                    ? `categorized-${category}`
                    : `categories-${category}`
            );
            const subcategoryText = formatText(
                NEW_PFM_FEATURES
                    ? `categorized-${subcategory}`
                    : `${category}-${subcategory}`
            );

            if (immTransaction.get("canBeRecategorized")) {
                editCategoryButton = (
                    <div className="account-last-movements-table-row__category-tooltip-button">
                        <i
                            className="icon-s-editar account-last-movements-table-row__category-tooltip-edit-icon"
                            onClick={this.handleOpenCategoriesModal}
                        />
                    </div>
                );
            } else {
                cantBeCategorizedInfoMessage = (
                    <p className="account-last-movements-table-row__category-tooltip-paragraph">
                        <FormattedText
                            className="account-last-movements-table-row__category-info-message"
                            value="accounts-cantBeCategorizedInfoMessage"
                        />
                    </p>
                );
            }

            const categoryTooltipContent = (
                <div className="account-last-movements-table-row__category-tooltip">
                    <p className="account-last-movements-table-row__category-tooltip-title">
                        {categoryText}
                    </p>
                    <div className="account-last-movements-table-row__category-tooltip-wrapper">
                        <p className={subCategoryTextClass}>
                            {subcategoryText}
                        </p>
                        {editCategoryButton}
                    </div>
                    {cantBeCategorizedInfoMessage}
                </div>
            );

            const okCategoryIcon = (
                <span>
                    <OKIconCategorization
                        icon={categoryIcon}
                        active={isExpanded}
                        iconUrl={NEW_PFM_FEATURES ? categoryIcon : null}
                    />
                </span>
            );

            categoryTooltip = (
                <OKTooltip
                    content={categoryTooltipContent}
                    offset={!__CONTACT_CENTER__ ? [0, -30] : undefined}
                    target={okCategoryIcon}
                    type="custom"
                />
            );
        }

        const description = toCamelCase(
            immTransaction.get("description").trim()
        );
        const plainAmountObject = getPlainAmountObject(
            immTransaction.get("balance")
        );
        const plainAmountTotalObject = getPlainAmountObject(
            immTransaction.get("totalBalance")
        );
        let expandCell;
        let dateRowClass = "account-last-movements-table-row__cell-date";

        if (isExpandable) {
            dateRowClass =
                "account-last-movements-table-row__cell-date--expandable";
            expandCell = (
                <OKTableCell className="account-last-movements-table-row__cell-expand">
                    <OKCollapsingToggler
                        handlerToggle={this.onRowClick}
                        isExpanded={this.props.isExpanded}
                        isIconSecondary
                    />
                </OKTableCell>
            );
        }

        return (
            <OKTableRow id={id} isExpanded={isExpanded}>
                {expandCell}
                <OKTableCell className={dateRowClass}>
                    <LabelDate
                        date={immTransaction.get("date")}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <ContactCenterRender>
                    {this.getValueDateCell(immTransaction, dateRowClass, id)}
                </ContactCenterRender>
                <FeatureTogglingRender notAllowedProductKey={PFM}>
                    <OKTableCell className="account-last-movements-table-row__cell-category">
                        {categoryTooltip}
                    </OKTableCell>
                </FeatureTogglingRender>
                <OKTableCell className="account-last-movements-table-row__cell-description">
                    <WebappRender>
                        <span>{description}</span>
                    </WebappRender>
                    <ContactCenterRender>
                        <OKTooltip
                            content={description}
                            target={
                                <span>
                                    <TruncateText
                                        str={description}
                                        charLimit={charLimit}
                                        lineAmount={2}
                                    />
                                </span>
                            }
                        />
                    </ContactCenterRender>
                </OKTableCell>
                {flagBasedFeatures.get("account-revolving", false) &&
                    this.renderDeferrablePayment(immTransaction)}
                <OKTableCell className="account-last-movements-table-row__cell-balance">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(
                            plainAmountObject,
                            true
                        )}
                    />
                </OKTableCell>
                <OKTableCell className="account-last-movements-table-row__cell-total-balance">
                    <OneLineSymbolAmount
                        amountObject={plainAmountTotalObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(
                            plainAmountTotalObject,
                            true
                        )}
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

AccountLastMovementsTableRow.propTypes = {
    accountDeepLinkResponse: PropTypes.object,
    charLimit: PropTypes.number,
    flagBasedFeatures: PropTypes.object,
    id: PropTypes.string,
    immTransaction: PropTypes.object,
    isExpandable: PropTypes.bool,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
    openCategoriesModal: PropTypes.func,
};

AccountLastMovementsTableRow.defaultProps = {
    className: "",
    onRowClick: function () {},
};

module.exports = connect(
    (state) => ({
        accountDeepLinkResponse: state.personeticsDeepLinks
            .get("accountMovementRequest")
            .toJS(),
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        openCategoriesModal: open,
    }
)(AccountLastMovementsTableRow);
